export default function postMessageToParent(name, data = {}) {
  const value = JSON.stringify({ name, data });

  if (window.ReactNativeWebView !== undefined) {
    window.ReactNativeWebView.postMessage(value, '*');
    return true;
  } else if (window.self !== window.top) {
    window.parent.postMessage(value, '*');
    return true;
  } else {
    return false;
  }
}
